export const AmlMatchStatusEnum = {
  no_match: 'no_match',
  potential_match: 'potential_match',
  false_positive: 'false_positive',
  true_positive: 'true_positive',
} as const;
export type AmlMatchStatusEnum =
  (typeof AmlMatchStatusEnum)[keyof typeof AmlMatchStatusEnum];
